<template>

  <!-- son los objetos que se arratran -->
  
  <div class="mx-auto"
    draggable
    @dragstart.self="onDrag"
    @dragover.prevent
    @dragenter.prevent >
    <slot/>
  </div>
</template>

<script>
export default {
  name:"AppDrag",
  props: {
    transferData: {
      type: Object,
      required: true
    },
  },
  methods: {
    onDrag (e) {
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.dropEffect = 'move'

      e.dataTransfer.setData('payload', JSON.stringify(this.transferData))
    }
  }
}
</script>

<style lang="css" scoped>
</style>
